import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  const [selected, setSelected] = useState<'premium' | 'basic'>('premium');
  const checkoutUrl = selected === 'basic' ? 'https://checkout.descargatop.com/cart/40898068152369:1' : 'https://checkout.descargatop.com/cart/40916383236145:1';
  return <section id="pricing" className="py-20 px-4 bg-[#111111] scroll-mt-10" data-id="element-101">
      <div className="max-w-3xl mx-auto" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-103">
          <div className="text-center mb-12" data-id="element-104">
            <h2 className="text-4xl md:text-6xl font-black text-white mb-4 uppercase tracking-tight" data-id="element-105">
              🛒 ELEGÍ TU PLAN
            </h2>
            <p className="text-lg text-gray-400 font-medium" data-id="element-106">
              Descarga inmediata. Acceso de por vida.
            </p>
          </div>

          <div className="space-y-4 mb-10" data-id="element-107">
            {/* Basic Plan Row */}
            <button onClick={() => setSelected('basic')} className={`w-full rounded-2xl p-5 md:p-6 flex items-center gap-4 md:gap-6 transition-all duration-300 cursor-pointer text-left ${selected === 'basic' ? 'bg-[#1a1a1a] border-2 border-gray-500' : 'bg-[#1a1a1a] border-2 border-[#2a2a2a] opacity-70 hover:opacity-90'}`} data-id="element-108">
              {/* Radio */}
              <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-colors ${selected === 'basic' ? 'border-white' : 'border-gray-600'}`} data-id="element-109">
                {selected === 'basic' && <div className="w-3 h-3 rounded-full bg-white" data-id="element-110" />}
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0" data-id="element-111">
                <div className="flex items-center gap-2 mb-1" data-id="element-112">
                  <span className="text-xl" data-id="element-113">📘</span>
                  <h3 className="text-lg md:text-xl font-black text-white uppercase tracking-wide" data-id="element-114">
                    PACK BÁSICO
                  </h3>
                </div>
                <p className="text-sm md:text-base text-gray-400 font-medium" data-id="element-115">
                  4 libros + 400 citas + bonos
                </p>
                <div className="flex flex-col gap-1 mt-2" data-id="element-116">
                  <p className="text-xs text-gray-400" data-id="element-117">
                    📘 100 Citas Mamá e Hija
                  </p>
                  <p className="text-xs text-gray-400" data-id="element-118">
                    📗 100 Citas Mamá e Hijo
                  </p>
                  <p className="text-xs text-gray-400" data-id="element-119">
                    📙 100 Citas Papá e Hija
                  </p>
                  <p className="text-xs text-gray-400" data-id="element-120">
                    📕 100 Citas Papá e Hijo
                  </p>
                </div>
              </div>

              {/* Price */}
              <div className="text-right flex-shrink-0" data-id="element-121">
                <p className="text-sm text-gray-500 line-through font-medium" data-id="element-122">
                  $25.99
                </p>
                <p className="text-3xl md:text-4xl font-black text-white" data-id="element-123">
                  $12.99
                </p>
              </div>
            </button>

            {/* Premium Plan Row */}
            <button onClick={() => setSelected('premium')} className={`w-full rounded-2xl p-5 md:p-6 flex items-center gap-4 md:gap-6 transition-all duration-300 cursor-pointer text-left relative overflow-hidden ${selected === 'premium' ? 'bg-gradient-to-br from-[#1a1a00] via-[#1a1500] to-[#1a1a00] border-2 border-yellow-400 shadow-[0_0_40px_rgba(250,204,21,0.25)]' : 'bg-[#1a1a1a] border-2 border-[#2a2a2a] opacity-70 hover:opacity-90'}`} data-id="element-124">
              {/* VIP shimmer accent */}
              {selected === 'premium' && <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-yellow-600 via-yellow-300 to-yellow-600" data-id="element-125"></div>}

              {/* Radio */}
              <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-colors ${selected === 'premium' ? 'border-yellow-400' : 'border-gray-600'}`} data-id="element-126">
                {selected === 'premium' && <div className="w-3 h-3 rounded-full bg-yellow-400" data-id="element-127" />}
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0" data-id="element-128">
                <div className="flex items-center gap-2 mb-2" data-id="element-129">
                  <span className="text-xl" data-id="element-130">🏆</span>
                  <h3 className="text-lg md:text-xl font-black text-yellow-400 uppercase tracking-wide" data-id="element-131">
                    PACK COMPLETO
                  </h3>
                </div>
                <div className="flex flex-wrap items-center gap-2 mb-2" data-id="element-132">
                  <span className="inline-flex items-center gap-1 bg-gradient-to-r from-yellow-500 via-amber-400 to-yellow-500 text-black text-xs font-black px-3 py-1 rounded-full uppercase tracking-wider shadow-md" data-id="element-133">
                    ⭐ Más elegido
                  </span>
                  <span className="inline-flex items-center text-yellow-400 text-xs font-bold px-3 py-1 rounded-full border border-yellow-400/50 uppercase tracking-wider bg-yellow-400/10" data-id="element-134">
                    Ahorrás $6
                  </span>
                </div>
                <p className="text-sm md:text-base text-gray-400 font-medium" data-id="element-135">
                  6 libros + 600 citas + bonos
                </p>
                <div className="flex flex-col gap-1 mt-2" data-id="element-136">
                  <p className="text-sm text-yellow-300 font-bold" data-id="element-137">
                    + 💑 100 Citas en Pareja
                  </p>
                  <p className="text-sm text-yellow-300 font-bold" data-id="element-138">
                    + 👨‍👩‍👧 100 Citas en Familia
                  </p>
                </div>
              </div>

              {/* Price */}
              <div className="text-right flex-shrink-0" data-id="element-139">
                <p className="text-sm text-gray-500 line-through font-medium" data-id="element-140">
                  $37.99
                </p>
                <p className="text-3xl md:text-4xl font-black text-yellow-400" data-id="element-141">
                  $18.99
                </p>
              </div>
            </button>
          </div>

          {/* Persuasive nudge for Pack Completo */}
          <div className="bg-gradient-to-r from-yellow-400/10 to-yellow-400/5 border border-yellow-400/30 rounded-xl p-4 mb-6 text-center" data-id="element-142">
            <p className="text-yellow-400 font-bold text-sm md:text-base mb-1" data-id="element-143">
              💡 ¿Por qué elegir el Pack Completo?
            </p>
            <p className="text-gray-300 text-sm leading-relaxed" data-id="element-144">
              Con el Pack Completo no solo fortalecés el vínculo con tus hijos,
              sino también{' '}
              <span className="text-white font-bold" data-id="element-145">
                con tu pareja y toda la familia
              </span>
              . Son{' '}
              <span className="text-yellow-400 font-bold" data-id="element-146">200 citas extra</span>{' '}
              por solo $6 más. La mayoría de los padres lo eligen porque saben
              que la conexión familiar empieza desde la pareja.{' '}
              <span className="text-yellow-400 font-bold" data-id="element-147">
                No te lo pierdas.
              </span>
            </p>
          </div>

          {/* Checkout CTA — links to actual checkout based on selection */}
          <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="block w-full" data-id="element-148">
            <motion.div whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} animate={{
            scale: [1, 1.02, 1]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="relative w-full group" data-id="element-149">
              <div className="absolute -inset-1 bg-gradient-to-r from-red-600 to-orange-500 rounded-xl blur opacity-70 group-hover:opacity-100 transition duration-200" data-id="element-150"></div>
              <div className="relative w-full flex flex-col items-center justify-center px-6 py-4 bg-gradient-to-b from-red-500 to-red-700 border-b-4 border-red-900 rounded-xl shadow-2xl text-white font-black text-xl md:text-2xl uppercase tracking-wide hover:from-red-400 hover:to-red-600 transition-all" data-id="element-151">
                <div className="flex items-center gap-2 text-center" data-id="element-152">
                  👉 COMPRAR AHORA
                </div>
                <span className="text-sm md:text-base font-medium text-red-100 mt-1 normal-case tracking-normal" data-id="element-153">
                  Descarga inmediata • Garantía de 7 días
                </span>
              </div>
            </motion.div>
          </a>

          <div className="flex items-center justify-center gap-4 mt-6 text-gray-500 text-sm" data-id="element-154">
            <span className="flex items-center gap-1" data-id="element-155">🔒 Pago seguro</span>
            <span data-id="element-156">•</span>
            <span className="flex items-center gap-1" data-id="element-157">
              📥 Descarga inmediata
            </span>
            <span data-id="element-158">•</span>
            <span className="flex items-center gap-1" data-id="element-159">✅ Garantía 7 días</span>
          </div>
        </motion.div>
      </div>
    </section>;
}